import {getPolicyQuestionnaireUrl} from '../../../url';
import PrintButton from '../ReactBootstrap/PrintButton';
import React from 'react';
import {printPolicyQuestionnaire} from '../../../print';
import PropTypes from 'prop-types';

const PolicyQuestionnairePrintButton = ({
    policy,

    ...props
}) => {
    return (
        <PrintButton icon="file-alt" printAction={() => printPolicyQuestionnaire(policy.id)}
            viewUrl={getPolicyQuestionnaireUrl(policy.id)}
            downloadUrl={getPolicyQuestionnaireUrl(policy.id, true)} objId={policy.id}
            additional={'questionnaire'} {...props} />
    );
};

PolicyQuestionnairePrintButton.defaultProps = {
    label: 'Въпросник',
    objType: 'policy',
};

PolicyQuestionnairePrintButton.propTypes = {
    label: PropTypes.string,
    objType: PropTypes.string,
    policy: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default PolicyQuestionnairePrintButton;
